// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import $ from "jquery";
// import router from './router'
require("./css/style.scss");

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  mounted: function() {
    $(window).trigger("loaded");
  }
});



// WEBPACK FOOTER //
// ./src/main.js